import React, { useState, useMemo, FC } from 'react';
import { FjInput } from 'components/primitives';
import { Modal } from '../styled-primitives';
import { fjModalSizes } from '../primitives/fj-modal';

const MIN_PASSWORD_LENGTH = 8;

type Props = FjDivProps & {
  device: Device;
  cancelCallback: () => void;
  acceptCallback: (password: string) => void;
};

export const ExportEotModal: FC<Props> = ({ device, cancelCallback, acceptCallback }: Props) => {
  const [password, setPassword] = useState('');
  const isValid = useMemo(() => password.length >= MIN_PASSWORD_LENGTH, [password]);

  const validatePassword = (val: string) => val.length >= MIN_PASSWORD_LENGTH || val.length === 0;

  return (
    <Modal
      dataTestId="export-eot-modal"
      cancel={{
        text: 'Cancel',
        callback: cancelCallback,
      }}
      accept={{
        text: 'Export',
        disabled: !isValid,
        callback: () => acceptCallback(password),
      }}
      title={`Export Extended Offline Token for: ${device.name}`}
      size={fjModalSizes.LG}
      showX
      onClickX={cancelCallback}
    >
      <div>
        <FjInput
          type="password"
          className="fj-input"
          value={password}
          placeholder="password"
          autoComplete="current-password"
          validator={validatePassword}
          getValidationMessage={() => 'Passwords must be 8 characters or longer.'}
          onChange={(val: string) => setPassword(val)}
        />
      </div>
    </Modal>
  );
};
